import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "../axios/AxiosInstance";
import { recentWorkers } from "../utils/recentWorkers";
import { expiredDocument } from "../utils/expiredDocument";
import { groupExpiredDocuments } from "../utils/groupExpiredDocuments";

const ExpiredDocumentsContext = createContext(null);

const demoRows = [
  ["Camille", "Martin", "Titre de séjour", "2026-09-15"],
  ["Alex", "Moreau", "Carte d’identité", "2026-08-30"],
  ["Sarah", "Bernard", "Autorisation de travail", "2026-09-25"],
  ["Hugo", "Petit", "CACES", "2026-10-01"],
  ["Emma", "Laurent", "Habilitation électrique", "2026-09-10"],
  ["Lucas", "Robert", "Titre de séjour", "2026-08-20"],
  ["Léa", "Dubois", "Carte d’identité", "2026-09-18"],
  ["Adam", "Michel", "CACES", "2026-09-28"],
  ["Chloé", "Simon", "Autorisation de travail", "2026-10-02"],
  ["Noah", "Roux", "Habilitation électrique", "2026-09-05"],
].map(([firstname, lastname, type, expirationDate], index) => ({
  candidate: { _id: `demo-expired-candidate-${index}`, firstname, lastname, status: index % 2 ? "En poste" : "En mission", isDemo: true },
  document: { _id: `demo-expired-document-${index}`, type, name: `${type} — exemple`, expirationDate },
}));
export function ExpiredDocumentsProvider({ children }) {
  const [examples, setExamples] = useState(() => [...demoRows, { candidate: demoRows[0].candidate, document: { _id: "demo-second-document", type: "Autorisation de travail", name: "Autorisation de travail — exemple", expirationDate: "2026-09-30" } }]);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [candidates, setCandidates] = useState([]);
  useEffect(() => {
    let active = true;
    async function load() {
      try {
        const [candidateResponse, contractResponse] = await Promise.all([
          axios.get("tempworker-candidate/freelance"),
          axios.get("pld-contract/freelance"),
        ]);
        const data = Array.isArray(candidateResponse.data) ? candidateResponse.data : [];
        const workers = recentWorkers(data, Array.isArray(contractResponse.data) ? contractResponse.data : []);
        let index = 0;
        let failures = 0;
        const results = [];
        await Promise.all(Array.from({length:Math.min(6,workers.length)},async () => {
          while (index < workers.length && active) {
            const candidate = workers[index++];
            try {
              const {data:documents} = await axios.get(`document/candidate/${candidate._id}`);
              (Array.isArray(documents) ? documents : []).filter(document => expiredDocument(document)).forEach(document => results.push({candidate,document}));
            } catch (error) { if (error.response?.status !== 404) failures++; }
          }
        }));
        if (active) { setCandidates(data); setRows(results); if (failures) setError(`${failures} dossier(s) n’ont pas pu être vérifiés. Actualisez la page pour réessayer.`); }
      } catch { if (active) setError("Impossible de charger les candidats et leurs documents."); }
      finally { if (active) setLoading(false); }
    }
    load();
    return () => { active = false; };
  }, []);
  const grouped = groupExpiredDocuments([...examples.filter(row => expiredDocument(row.document)), ...rows]);
  const total = grouped.reduce((sum, group) => sum + group.documents.length, 0);
  return <ExpiredDocumentsContext.Provider value={{ examples, setExamples, loading, error, candidates, setCandidates, grouped, total }}>{children}</ExpiredDocumentsContext.Provider>;
}

export function useExpiredDocuments() {
  return useContext(ExpiredDocumentsContext);
}
